/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pc-title.vue?vue&type=template&id=3535d126&scoped=true"
import script from "./pc-title.vue?vue&type=script&lang=js"
export * from "./pc-title.vue?vue&type=script&lang=js"
import style0 from "./pc-title.vue?vue&type=style&index=0&id=3535d126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3535d126",
  null
  
)

export default component.exports